import _createClass from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
export function isNumber(val) {
  return typeof val === 'number';
}
export function sum(items) {
  return items.reduce(function (acc, width) {
    return acc + width;
  }, 0);
}
export function sanatizeInteger(maybeInteger) {
  return typeof maybeInteger === 'number' && Number.isInteger(maybeInteger) ? maybeInteger : undefined;
}
export function sanatizeBoolean(maybeBoolean) {
  return typeof maybeBoolean === 'boolean' ? maybeBoolean : undefined;
}
// TODO: use native findLastIndex in next major release
export function findLastIndex(array, predicate) {
  for (var k = array.length - 1; k >= 0; k--) {
    if (predicate(array[k])) return k;
  }
  return -1;
}
export var UnsupportedValueError = /*#__PURE__*/function (_Error) {
  _inherits(UnsupportedValueError, _Error);
  var _super = _createSuper(UnsupportedValueError);
  function UnsupportedValueError(value) {
    _classCallCheck(this, UnsupportedValueError);
    return _super.call(this, 'Unsupported value: ' + value);
  }
  return _createClass(UnsupportedValueError);
}( /*#__PURE__*/_wrapNativeSuper(Error));